// File: utils/parseHtmlSectionsToComponents.ts
import { COMPONENT_TYPES } from "./constants";

interface ComponentData {
  id: string;
  type: string;
  parentId: string | null;
  order: number;
  props: {
    text: string;
    fontSize: number;
    textAlign: string;
    color: string;
    className?: string;
    tagName?: string;
    shortcodes?: string[];
    attributes?: Record<string, string>;
  };
}

export const parseHtmlSectionsToComponents = (
  html: string
): ComponentData[] => {
  const container = document.createElement("div");
  container.innerHTML = html;

  const sections = container.querySelectorAll("section.main, div");
  if (!sections.length) return [];

  // Helper to extract shortcodes (assuming format like [shortcode param="value"])
  const extractShortcodes = (text: string): string[] => {
    const shortcodeRegex = /\[([^\]]+)\]/g;
    const matches = text.match(shortcodeRegex);
    return matches ? Array.from(matches) : [];
  };

  // Helper to extract attributes from an element
  const extractAttributes = (element: Element): Record<string, string> => {
    const attributes: Record<string, string> = {};
    Array.from(element.attributes).forEach((attr) => {
      attributes[attr.name] = attr.value;
    });
    return attributes;
  };

  return Array.from(sections)
    .filter((section) => {
      // Skip sections containing a div with id="toc-id" or elements with class "scoreBreakdown-link"
      const hasTocId = section.querySelector("div#toc-id");

      return !hasTocId;
    })
    .map((section, index) => {
      const shortcodes = extractShortcodes(section.innerHTML);
      const attributes = extractAttributes(section);

      // Preserve all existing data structure
      const component: ComponentData = {
        id: `${Date.now()}-${index}`,
        type:
          section.tagName === "SECTION"
            ? COMPONENT_TYPES.TEXT
            : COMPONENT_TYPES.WIDGET,
        parentId: null,
        order: index + 1,
        props: {
          text: section.innerHTML,
          fontSize: 16,
          textAlign: "left",
          color: "#000000",
          className: section.className || undefined,
          tagName: section.tagName.toLowerCase(),
          ...(shortcodes.length ? { shortcodes } : {}),
          attributes,
        },
      };

      return component;
    });
};
